// extracted by mini-css-extract-plugin
export default {"logo1":"style_logo1__iwp6H","logo2":"style_logo2__2bIYU"};